import React, { useState, useEffect, useRef } from "react";
import { PageLayout } from "./components/PageLayout";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import axios from "axios";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "./css/stylenew.css";
import "./styles/App.css";
import {} from "./skapa/select.js";
import { Button } from "./skapa/button.js";
import { JumboButton } from "./skapa/jumbo.js";
import "@ingka/modal/dist/style.css";
import { Loading } from "./skapa/loading";
import { Modal, Prompt, ModalFooter, ModalHeader } from "./skapa/modal.js";
import { Text } from "./skapa/text.js";
import { Table } from "./skapa/table";
import "@ingka/table/dist/style.css";
import { API_HOST } from "./config.js"; // Import the host URL from the config file

const CountryList = ({
  onCountrySelect,
  adminSA,
  setAdminSA,
  adminBH,
  setAdminBH,
}) => {
  const [countryList, setCountryList] = useState([]);
  const [error, setError] = useState("");
  const [error1, setError1] = useState("");
  const [countFetched, setCountFetched] = useState(false);
  const [errorrolesnotdefined, setErrorrolesnotdefined] = useState("");
  // Define showLoader state variable and its setter function
  const [showLoader, setShowLoader] = useState(false);
  const { accounts } = useMsal();
  const email = accounts[0].username;
  const [isOkBtnEnabled, setIsOkBtnEnabled] = useState(false);
  const [isOkBtnOtpEnabled, setIsOkBtnOtpEnabled] = useState(false);
  const [showCheckCountModal, setShowCheckCountModal] = useState(false);
  const [showEnterOtpModal, setShowEnterOtpModal] = useState(false);
  const [showCheckCountModalBH, setShowCheckCountModalBH] = useState(false);
  const [showCountTextBox, setShowCountTextBox] = useState(false);
  const [verifyButtonVisible, setVerifyButtonVisible] = useState(false);
  const [mobileNo, setMobileNo] = useState("");
  const [sendOtp, setSendOtp] = useState("");
  const [smsOtp, setSmsOtp] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [showVerifyOtpModal, setShowVerifyOtpModal] = useState(false);
  const [modalPreviouslyOpened, setModalPreviouslyOpened] = useState(false);
  const [showMobileNoVerifiedModal, setShowMobileNoVerifiedModal] =
    useState(false);
  const [countryMobileCode, setCountryMobileCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMobileNotFound, setErrorMobileNotFound] = useState("");
  const [registeredCount, setRegisteredCount] = useState(null);
  const [mobileVerifiedCount, setMobileVerifiedCount] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [languageList, setLanguageList] = useState([]);
  const [languageCode, setLanguageCode] = useState("");
  const [email1, setEmail1] = useState("");
  const [data, setData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const modalTitleId = "mymodaltitle";
  const [isLoadingCountry, setIsLoadingCountry] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSmsEnabled, setIsSmsEnabled] = useState(false);
  const [hasCheckBox, setHasCheckBox] = useState(false);
  const [isLanguageEnabled, setIsLanguageEnabled] = useState(false);
  const [isEmailEmpty, setIsEmailEmpty] = useState(true);
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [showPasswordSentModal, setShowPasswordSentModal] = useState(false);
  const [showPolicyModal, setshowPolicyModal] = useState(false);
  const [isInputEnabled, setIsInputEnabled] = useState(false);
  const [isLanguageSelected, setIsLanguageSelected] = useState(false);
  const [showError, setShowError] = useState(false);
  const [comType, setComType] = useState("");
  const [jwtToken, setJwtToken] = useState("");
  //  const isOkButtonEnabled = isMobileValid ? isOkEnabled : false;
  const openVerifyOtpModal = () => {
    setShowVerifyOtpModal(true);
  };

  // Function to close the modal
  const closeVerifyOtpModal = () => {
    setShowVerifyOtpModal(false);
  };
  // Convert the string "true" or "false" to a boolean
  const isMobileNumberVerified =
    data &&
    data.verifiedMobileNumber &&
    data.verifiedMobileNumber.toLowerCase() === "true";

  {
    isSmsEnabled && <td>{isMobileNumberVerified ? "Yes" : "No"}</td>;
  }

  // const isMobileNumberVerified = !!responseData.verifiedMobileNumber;

  const [resetMethod, setResetMethod] = useState(
    isSmsEnabled ? "email,sms" : "email"
  );
  // If either email or sms is checked, enable the "Ok" button
  const isOkEnabled =
    resetMethod.includes("email") || resetMethod.includes("sms");

  useEffect(() => {
    const fetchCountryList = async () => {
      setIsLoadingCountry(true); // Set loading state to true
      try {
        const response = await axios.get(
          `${API_HOST}/hantera/country-list/${email}`
        );

        // Update the adminSA and adminBH using setAdminSA and setAdminBH
        setAdminSA(response.data.adminSA || false);
        setAdminBH(response.data.adminBH || false);

        // Get JWT token from response
        const fetchedJwtToken = response.data.token;
        // Store the JWT token in localStorage
        localStorage.setItem("jwtToken", fetchedJwtToken);

        // Set the JWT token state
        setJwtToken(fetchedJwtToken);

        // Assuming the response is an array of country names
        const countryListFromResponse = response.data.countryList || [];

        if (countryListFromResponse.length > 0) {
          setCountryList(countryListFromResponse);
          setIsLoadingCountry(false);
          setErrorrolesnotdefined("");
        } else {
          setCountryList([]);
          setErrorrolesnotdefined("Roles not defined");
        }
      } catch (error) {
        // Handle error cases here
        setCountryList([]);
        setErrorrolesnotdefined("Roles not defined");
        setIsLoadingCountry(false); // Set loading state to false
      }
    };
    fetchCountryList();
  }, [email, adminSA, adminBH]);

  const fetchDataCount = async () => {
    try {
      const jwtToken = localStorage.getItem("jwtToken");

      // Check if the token is available
      if (!jwtToken) {
        // Handle the case where the token is not available
        console.error("JWT Token not available");
        return;
      }
      const url = `${API_HOST}/hantera/customerdata/registeredCount`;

      const response = await axios.get(url, {
        params: {
          market: "Saudi Arabia",
        },
        headers: {
          Authorization: jwtToken, // Remove "Bearer" prefix here
        },
      });

      // Update the state with the received count
      setRegisteredCount(response.data.registeredCustomerCount);
      setMobileVerifiedCount(response.data.mobileVerifiedCount);
      setShowCheckCountModal(true);
    } catch (error) {
      // Handle errors
    }
  };

  const handleCountButtonClick = () => {
    fetchDataCount();
  };

  const handleCancelClick = () => {
    // Close the modal
    setShowCheckCountModal(false);
  };

  const handleCountDetailsClick = () => {
    // Clear the registeredCount state to reset the input field
    setRegisteredCount(null);
    // Open the modal
    // setShowCheckCountModal(true);
    fetchDataCount();
  };

  const fetchDataCountBH = async () => {
    try {
      // Get the JWT token from local storage
      const jwtToken = localStorage.getItem("jwtToken");

      // Check if the token is available
      if (!jwtToken) {
        // Handle the case where the token is not available

        return;
      }
      const url = `${API_HOST}/hantera/customerdata/registeredCount`;
      // Log the Authorization header value for testing

      const response = await axios.get(url, {
        params: {
          market: "Bahrain",
        },
        headers: {
          Authorization: jwtToken, // Remove "Bearer" prefix here
        },
      });
      // Update the state with the received count
      setRegisteredCount(response.data.registeredCustomerCount);
      setMobileVerifiedCount(response.data.mobileVerifiedCount);
      setShowCheckCountModalBH(true);
      // setShowCountTextBox(true);  // Show the text box with count
      // Handle the response data as needed
    } catch (error) {
      // Handle errors
    }
  };

  const handleCountButtonClickBH = () => {
    fetchDataCountBH();
  };

  const handleCancelClickBH = () => {
    // Close the modal
    setShowCheckCountModal(false);
  };

  const handleCountDetailsClickBH = () => {
    // Clear the registeredCount state to reset the input field
    setRegisteredCount(null);
    // Open the modal
    // setShowCheckCountModalBH(true);
    fetchDataCountBH();
  };

  useEffect(() => {
    const fetchLanguageList = async () => {
      try {
        // Get the JWT token from local storage
        const jwtToken = localStorage.getItem("jwtToken");

        // Check if the token is available
        if (!jwtToken) {
          // Handle the case where the token is not available

          return;
        }
        const response = await axios.get(
          `${API_HOST}/hantera/language-list/${selectedCountry}`,
          {
            headers: {
              Authorization: jwtToken,
            },
          }
        );
        setLanguageList(response.data);
      } catch (error) {
        setError("Error fetching language list");
      }
    };

    if (selectedCountry) {
      fetchLanguageList();
      setIsLanguageEnabled(true); // enable language dropdown if country is selected
    } else {
      setLanguageList([]);
      setIsLanguageEnabled(false); // disable language dropdown if country is not selected
    }
  }, [selectedCountry]);

  const handleVerifyButtonClick = () => {
    setShowVerifyOtpModal(true);
    setModalPreviouslyOpened(true);
    // Reset mobile number input field
    setMobileNo("");
    setErrorMessage("");
    setSmsOtp("");
    setErrorMobileNotFound("");
  };

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    setData(null); // reset data state to null
    setIsTableVisible(false); // hide the table
    setError1("");
    setEmail1("");
    setError(null);

    // No need to set verifyButtonVisible anymore
    // setVerifyButtonVisible(
    //   e.target.value === "Saudi Arabia" || e.target.value === "Bahrain"
    // ); // Enable verify button if the selected country is "Saudi Arabia"

    if (isSmsEnabled && e.target.value !== selectedCountry) {
      setResetMethod("email1");
    }

    // Disable input field and reset language state if "Select a country" is selected
    if (e.target.value === "") {
      setIsInputEnabled(false);
      setLanguageCode("");
      setIsLanguageSelected(false);
    }
  };

  const handleLanguageChange = (e) => {
    if (!e.target.value) {
      // Check if language is deselected
      setData(null); // reset data state to null
      setEmail1(""); // Reset email1 state to an empty string
      setLanguageCode(""); // Reset languageCode state to an empty string
      setError(null);
      setIsInputEnabled(false); // disable input field when language is deselected
    } else {
      setLanguageCode(e.target.value);
      setIsLanguageSelected(true);
      setIsInputEnabled(true); // enable input field when language is selected
    }
  };

  const handleEmailChange = (e) => {
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isEmailValid = emailRegex.test(e.target.value);
    setEmail1(e.target.value);
    setError(null); // Clear any previous error messages
    setError1("");
    setData(null);
    if (!isEmailValid && e.target.value !== "") {
      setError("Please enter a valid email address");
    }
    setIsEmailEmpty(e.target.value === "");
    if (e.target.value === "") {
      setData(null);
      setModalOpen(false);
    }
  };

  useEffect(() => {
    // Reset isMobileValid when the modal is closed
    if (!showVerifyOtpModal) {
      setIsMobileValid(false);
    }
  }, [showVerifyOtpModal]);

  // Function to open the modal

  useEffect(() => {
    // Reset isMobileValid when the modal is closed
    if (!showEnterOtpModal) {
      setIsOtpValid(false);
    }
  }, [showEnterOtpModal]);

  const handleMobileNoChange = (event) => {
    let { value } = event.target;

    // Remove any non-digit characters from the input value
    value = value.replace(/\D/g, "");

    // Add '+' at the beginning if not present
    if (!value.startsWith("+")) {
      value = `+${value}`;
    }

    // Trim the value based on the selected country
    const maxDigits = selectedCountry === "Saudi Arabia" ? 13 : 12;
    value = value.slice(0, maxDigits);

    // Check if the value matches the desired pattern based on the selected country
    const isValidMobileNo =
      selectedCountry === "Saudi Arabia" ? /^\+966\d{9}$/ : /^\+973\d{8}$/;

    console.log("Input Value:", value);
    console.log("Is Mobile Valid:", isValidMobileNo.test(value));

    setMobileNo(value);
    setIsMobileValid(isValidMobileNo.test(value));
    // Clear error message only if mobile number is valid
    if (isValidMobileNo.test(value)) {
      setErrorMobileNotFound("");
    }
  };

  const handleFirstModalOkClick = () => {
    // If mobile number is not valid, do not proceed with the API call
    if (!isMobileValid) {
      return;
    }

    // Show loader while waiting for API response
    setShowLoader(true);

    // Construct payload as a string representing the mobile number
    const payload = { mobileNumber: mobileNo };

    // Retrieve JWT token from local storage
    const jwtToken = localStorage.getItem("jwtToken");

    if (!jwtToken) {
      // Handle the case where the token is not available
      console.error("JWT Token not available");
      return;
    }

    axios
      .post(`${API_HOST}/hantera/send-otp`, payload, {
        headers: {
          Authorization: jwtToken,
          "Content-Type": "application/json",
        },
        validateStatus: function (status) {
          // Accept only status codes in the range of 2xx and 404
          return (status >= 200 && status < 300) || status === 404;
        },
      })
      .then((response) => {
        // Handle success response here
        if (response.status === 404) {
          // Handle 404 status code separately
          console.log("Mobile Number not found");
          setShowVerifyOtpModal(true); // Keep the modal open on error
          setErrorMobileNotFound("Mobile Number not found");
          setIsOkBtnEnabled(false);
        } else {
          // Reset the error message for invalid mobile number
          //  setShowVerifyOtpModal(true);
          setShowEnterOtpModal(true);
          setErrorMobileNotFound(""); // Clear the error message
          setIsOkBtnEnabled(true);
        }
      })
      .catch((error) => {
        // Handle error here
        console.error("Error sending OTP:", error);
        if (error.response && error.response.data) {
          // If there is a response from the server, handle it
          const errorMobileNotFound = error.response.data;
          setErrorMobileNotFound(errorMobileNotFound); // Set the error message
          setShowVerifyOtpModal(true);
          setIsOkBtnEnabled(false);
        } else {
          // If there is no response or data, display a generic error message
          setErrorMobileNotFound(
            "An error occurred while verifying OTP. Please try again later."
          );
          setShowVerifyOtpModal(true); // Keep the modal open on error
          setIsOkBtnEnabled(false);
        }
      })
      .finally(() => {
        setShowLoader(false); // Hide the loader
      });
  };

  // const handleInputChange = (event) => {
  //   const inputValue = event.target.value;
  //   setSmsOtp(inputValue);
  //   setIsOtpValid(inputValue.trim() !== ""); // Check if input is not empty
  //   // Clear error message when user starts typing
  //   setErrorMessage("");
  // };

  // Function to handle OTP input change
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setSmsOtp(inputValue);

    // Regular expression to validate OTP (6 digits only)
    const otpRegex = /^\d{6}$/;

    // Check if input matches the regex pattern
    const isValid = otpRegex.test(inputValue);

    setIsOtpValid(isValid); // Set OTP validity state

    // Show error message if input is not valid
    if (!isValid) {
      setErrorMessage("Enter a valid 6-digit OTP");
    } else {
      setErrorMessage(""); // Clear error message if input is valid
    }
  };

  const handleSecondModalOkClick = () => {
    // Show loader while waiting for API response
    setShowLoader(true);

    // Construct payload with correct field name
    const payload = { smsOtp: smsOtp };

    // Retrieve JWT token from local storage
    const jwtToken = localStorage.getItem("jwtToken");

    // Check if the token is available
    if (!jwtToken) {
      // Handle the case where the token is not available
      console.error("JWT Token not available");
      return;
    }

    axios
      .post(`${API_HOST}/hantera/verify-otp`, payload, {
        headers: {
          Authorization: jwtToken,
          "Content-Type": "application/json",
        },
        validateStatus: function (status) {
          // Accept only status codes in the range of 2xx and 400
          return (status >= 200 && status < 300) || status === 400;
        },
      })
      .then((response) => {
        // Handle success response here
        if (response.status === 400) {
          // Handle 400 status code separately
          console.log("OTP verification failed");
          // const errorMessage = "OTP verification failed";
          setErrorMessage("OTP NOT MATCHED"); // Set the error message
          setShowEnterOtpModal(true);
          // setIsOkBtnOtpEnabled(false);
          setIsOkBtnEnabled(false);
        } else {
          // OTP verification successful
          console.log("OTP verification successful");
          setShowEnterOtpModal(false);
          setShowMobileNoVerifiedModal(true);
          // Reset mobile number input field
          setSmsOtp("");
          setIsOtpValid(false);
          // setIsOkBtnOtpEnabled(true); // Enable the OK button
          setIsOkBtnEnabled(true);
        }
      })
      .catch((error) => {
        // Handle error here
        console.error("Error sending OTP:", error);
        if (error.response && error.response.data) {
          // If there is a response from the server, handle it
          const errorMobileNotFound = error.response.data;
          setErrorMobileNotFound(errorMobileNotFound); // Set the error message
          setShowVerifyOtpModal(true);
          // setIsOkBtnOtpEnabled(false);
          setIsOkBtnEnabled(false);
        } else {
          // If there is no response or data, display a generic error message
          setErrorMobileNotFound(
            "An error occurred while verifying OTP. Please try again later."
          );
          setShowEnterOtpModal(true); // Keep the modal open on error
          // setIsOkBtnOtpEnabled(false);
          setIsOkBtnEnabled(false);
        }
      })
      .finally(() => {
        setShowLoader(false); // Hide the loader
      });
  };

  useEffect(() => {
    const fetchFlags = async () => {
      try {
        const response = await axios.get(
          `${API_HOST}/hantera/email-sms-flags/${selectedCountry}`
        );
        setHasCheckBox(response.data.hasCheckBox);
        setIsSmsEnabled(response.data.smscountry);
      } catch (error) {}
    };
    fetchFlags();
  }, [selectedCountry]);

  const handleSearch = async () => {
    setIsLoading(true);

    try {
      // Get the JWT token from local storage
      const jwtToken = localStorage.getItem("jwtToken");

      // Check if the token is available
      if (!jwtToken) {
        return;
      }

      
      // Make the API call with the token in the headers
      const smsEnabledResponse = await axios.get(
        `${API_HOST}/hantera/email-sms-flags/${selectedCountry}`,
        {
          headers: {
            Authorization: jwtToken,
          },
        }
      );

      setIsSmsEnabled(smsEnabledResponse.data.smscountry);

      const response = await axios.get(
        `${API_HOST}/hantera/customer-details/${selectedCountry}/${email1}`,
        {
          headers: {
            Authorization: jwtToken,
          },
        }
      );

      const responseData = response.data;

      setIsTableVisible(true);

      if (responseData.countryCode !== selectedCountry) {
        setError1(
          `No profile with the email ${email1} was found in the currently selected country but a match was found in [${responseData.countryCode}]. Please select a valid country.`
        );

        setData(null);
        setModalOpen(true);
      } else {
        if (responseData.verifiedMobileNumber === "true") {
        } else {
          console.log("Mobile number is not verified!");
        }

        setData(responseData);
        setError(null);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setError("No Customer Information Found");
      } else {
        setError("Customer not found");
      }
      setData(null);
    } finally {
      setIsLoading(false);
    }
  };

  function handleOkClick() {
    const resetMethodArr = resetMethod.split(",");
    let comType = "";

    if (resetMethodArr.includes("email") && resetMethodArr.includes("sms")) {
      comType = "EMAIL-SMS"; // Set to "EMAIL-SMS" when both email and SMS are selected
    } else if (resetMethodArr.includes("sms")) {
      comType = "SMS"; // Set to "SMS" when only SMS is selected
    } else {
      comType = "EMAIL"; // Set to "EMAIL" when only email is selected or none are selected
    }

    // Get the JWT token from local storage
    const jwtToken = localStorage.getItem("jwtToken");

    // Check if the token is available
    if (!jwtToken) {
      // Handle the case where the token is not available
      console.error("JWT Token not available");
      return;
    }

    axios
      .post(
        `${API_HOST}/hantera/reset-password`,
        {
          emailId: email1,
          language: languageCode,
          countryCode: selectedCountry,
          comType: comType,
        },
        {
          headers: {
            Authorization: jwtToken,
          },
        }
      )
      .then(function (response) {
        // handle success response here
        setShowPasswordSentModal(true);
      })
      .catch(function (error) {});

    // Reset SMS option if it was unchecked or if the profile is not SMS-enabled with a mobile number
    if (
      (resetMethodArr.includes("sms") && !isSmsEnabled) ||
      !isMobileNumberVerified
    ) {
      setResetMethod("email");
    }
  }

  const handleCloseBtn = () => {
    setShowCheckCountModal(false);
    setModalOpen(false);
    setShowError(false); // reset error state when modal is closed
  };

  useEffect(() => {
    if (prevIsSmsEnabled && !isSmsEnabled) {
      setResetMethod("email");
    }
  }, [isSmsEnabled]);

  const prevIsSmsEnabled = usePrevious(isSmsEnabled);

  function usePrevious(value) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]);

    return ref.current;
  }

  const isSearchButtonDisabled =
    !selectedCountry || !languageCode || !email1 || !!error;

  return (
    <>
      {errorrolesnotdefined ? (
        <div className="textlogincenter">
          <Text tagName="h2" headingSize="m">
            {" "}
            {errorrolesnotdefined}{" "}
          </Text>
        </div>
      ) : (
        <>
          <div className="header">
            <div className="loggedinuser">
              <Text className="text text--heading-xl">
                Welcome {accounts[0].name}
              </Text>
            </div>

            <div className="button-container">
              {/* Add the buttons here */}
              {adminSA && (
                <Button
                  aria-disabled="false"
                  type="button"
                  className="btn btn--emphasised openmodalcountSA"
                  onClick={handleCountDetailsClick}
                >
                  <span className="btn__inner">
                    <span className="btn__label">Count SA</span>
                  </span>
                </Button>
              )}

              {adminBH && (
                <Button
                  aria-disabled="false"
                  type="button"
                  className="btn btn--emphasised openmodalcountBH"
                  onClick={handleCountDetailsClickBH}
                >
                  <span className="btn__inner">
                    <span className="btn__label">Count BH</span>
                  </span>
                </Button>
              )}
            </div>
          </div>

          <Modal
            visible={showCheckCountModal}
            escapable={false}
            handleCloseBtn={() => setShowCheckCountModal(false)}
          >
            <Prompt
              aria-labelledby={modalTitleId}
              titleId={modalTitleId}
              header={<ModalHeader ariaCloseTxt="Close prompt" />}
              footer={
                <ModalFooter
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div
                    className="primary"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className="passwordsentsuccessfullyok"
                      style={{ textAlign: "center", margin: "auto" }}
                    >
                      <Button
                        aria-disabled="false"
                        type="button"
                        className="btn btn--emphasised"
                        onClick={handleCancelClick}
                      >
                        <span className="btn__inner">
                          <span className="btn__label">CANCEL</span>
                        </span>
                      </Button>
                    </div>
                  </div>
                </ModalFooter>
              }
            >
              <div className="form-field">
                <legend className="total-count-label">
                  Total count of existing account and verified mobile accounts
                </legend>
                <div className="count-container">
                  <label htmlFor="countOfExistingAccount">
                    Count of existing account
                  </label>
                  <div className="count-value">
                    <input
                      type="text"
                      id="countOfExistingAccount"
                      value={registeredCount !== null ? registeredCount : ""}
                      readOnly
                    />
                  </div>
                </div>
                <div className="count-container" style={{ margin: "10px 0" }}>
                  <label htmlFor="countOfMobileVerifiedCount">
                    Count of mobile accounts
                  </label>
                  <div className="count-value">
                    <input
                      type="text"
                      id="countOfMobileAccounts"
                      value={
                        mobileVerifiedCount !== null ? mobileVerifiedCount : ""
                      }
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </Prompt>
          </Modal>

          <Modal
            visible={showCheckCountModalBH}
            escapable={false}
            handleCloseBtn={() => setShowCheckCountModalBH(false)}
          >
            <Prompt
              aria-labelledby={modalTitleId}
              titleId={modalTitleId}
              header={<ModalHeader ariaCloseTxt="Close prompt" />}
              footer={
                <ModalFooter
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div
                    className="primary"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className="passwordsentsuccessfullyok"
                      style={{ textAlign: "center", margin: "auto" }}
                    >
                      <Button
                        aria-disabled="false"
                        type="button"
                        className="btn btn--emphasised"
                        onClick={handleCancelClick}
                      >
                        <span className="btn__inner">
                          <span className="btn__label">CANCEL</span>
                        </span>
                      </Button>
                    </div>
                  </div>
                </ModalFooter>
              }
            >
              <div className="form-field">
                <legend className="total-count-label">
                  Total count of existing account and verified mobile accounts
                </legend>
                <div className="count-container">
                  <label htmlFor="countOfExistingAccount">
                    Count of existing account
                  </label>
                  <div className="count-value">
                    <input
                      type="text"
                      id="countOfExistingAccount"
                      value={registeredCount !== null ? registeredCount : ""}
                      readOnly
                    />
                  </div>
                </div>
                <div className="count-container" style={{ margin: "10px 0" }}>
                  <label htmlFor="countOfMobileAccounts">
                    Count of mobile accounts
                  </label>
                  <div className="count-value">
                    <input
                      type="text"
                      id="countOfMobileAccounts"
                      value={
                        mobileVerifiedCount !== null ? mobileVerifiedCount : ""
                      }
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </Prompt>
          </Modal>

          <Modal
            visible={showVerifyOtpModal}
            escapable={false}
            handleCloseBtn={() => setShowVerifyOtpModal(false)}
          >
            <Prompt
              aria-labelledby={modalTitleId}
              titleId={modalTitleId}
              header={<ModalHeader ariaCloseTxt="Close prompt" />}
              footer={
                <ModalFooter
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div
                    className="primary"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className=""
                      style={{ textAlign: "center", margin: "auto" }}
                    >
                      <button
                        type="button"
                        onClick={handleFirstModalOkClick}
                        disabled={!isMobileValid}
                        style={{
                          width: "200px",
                          borderRadius: "25px",
                          backgroundColor: isMobileValid
                            ? "rgb(0, 88, 163)"
                            : "#ddd",
                          border: "none",
                          color: "#fff",
                          padding: "14px 16px",
                          cursor: isMobileValid ? "pointer" : "not-allowed",
                        }}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </ModalFooter>
              }
            >
              <div className="form-field">
                <label htmlFor="mobileNo" className="label">
                  <legend>Enter Mobile No</legend>
                </label>
                <input
                  type="tel"
                  id="mobileNo"
                  name="mobileNo"
                  className="input"
                  value={mobileNo}
                  onChange={handleMobileNoChange}
                />
                <div style={{ minHeight: "20px", marginBottom: "10px" }}>
                  {/* Render the "Enter a valid mobile number" error only when isMobileValid is false and errorMobileNotFound is empty */}
                  {!isMobileValid && !errorMobileNotFound && (
                    <p style={{ color: "red", margin: 0 }}>
                      Enter a valid mobile number
                    </p>
                  )}
                  {/* Render the errorMobileNotFound message if it's not empty */}
                  {errorMobileNotFound && (
                    <p style={{ color: "red", margin: 0 }}>
                      {errorMobileNotFound}
                    </p>
                  )}
                </div>
              </div>
            </Prompt>
          </Modal>

          <Modal
            visible={showEnterOtpModal}
            escapable={false}
            handleCloseBtn={() => setShowEnterOtpModal(false)}
          >
            <Prompt
              aria-labelledby={modalTitleId}
              titleId={modalTitleId}
              header={<ModalHeader ariaCloseTxt="Close prompt" />}
              footer={
                <ModalFooter
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div
                    className="primary"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className=""
                      style={{ textAlign: "center", margin: "auto" }}
                    >
                      <button
                        type="button"
                        onClick={handleSecondModalOkClick}
                        disabled={!isOtpValid}
                        style={{
                          width: "200px",
                          borderRadius: "25px",
                          backgroundColor: isOtpValid
                            ? "rgb(0, 88, 163)"
                            : "#ddd",
                          border: "none",
                          color: "#fff",
                          padding: "14px 16px",
                          cursor: isOtpValid ? "pointer" : "not-allowed",
                        }}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </ModalFooter>
              }
            >
              <div className="form-field">
                <label htmlFor="otpNo" className="label">
                  <legend>Enter OTP</legend>
                </label>
                <input
                  type="text"
                  id="otpNo"
                  name="otpNo"
                  className="input"
                  value={smsOtp}
                  onChange={handleInputChange}
                />
                <div style={{ minHeight: "20px", marginBottom: "10px" }}>
                  {/* Show error message if OTP is not valid */}
                  {!isOtpValid && !errorMessage && (
                    <p style={{ color: "red", margin: 0 }}>
                      Enter a valid 6-digit OTP
                    </p>
                  )}
                  {/* Render the errorMobileNotFound message if it's not empty */}
                  {errorMessage && (
                    <p style={{ color: "red", margin: 0 }}>{errorMessage}</p>
                  )}
                </div>
                {/* <p style={{ color: "red" }}>{errorMessage}</p> */}
              </div>
            </Prompt>
          </Modal>

          <Modal
            visible={showMobileNoVerifiedModal}
            escapable={false}
            handleCloseBtn={() => setShowMobileNoVerifiedModal(false)}
          >
            <Prompt
              aria-labelledby={modalTitleId}
              titleId={modalTitleId}
              header={<ModalHeader ariaCloseTxt="Close prompt" />}
              footer={
                <ModalFooter
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div
                    className="primary"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className="passwordsentsuccessfullyok"
                      style={{ textAlign: "center", margin: "auto" }}
                    >
                      <Button
                        aria-disabled="false"
                        class="btn btn--emphasised"
                        type="primary"
                        onClick={() => setShowMobileNoVerifiedModal(false)} // Ensure you handle closing of the modal
                      >
                        <span class="btn__inner">
                          <span class="btn__label">OK</span>{" "}
                        </span>{" "}
                      </Button>
                    </div>
                  </div>
                </ModalFooter>
              }
            >
              <div class="form-field">
                <div class="form-field__content">
                  <span
                    id="helper-msg-id"
                    class="helper-text"
                    style={{ color: "rgb(17, 17, 17)" }}
                  >
                    <Text tagName="h2" headingSize="m">
                      Mobile number verified!
                    </Text>
                  </span>
                </div>
              </div>
            </Prompt>
          </Modal>

          <div>
            <div className="main-container"></div>

            {/* Text */}
            <div className="regform">
              <Text tagName="h2" headingSize="m">
                Find customer details
              </Text>
            </div>

            {/* <div className="regform1"> */}
            <div className="regform1">
              <Text className="text text--heading-xl">
                To search for a customer details, please select country,
                language code and enter Email Id of the customer.
              </Text>
            </div>

            <div className="grid-container">
              <div className="grid-item">
                <div className="form-field">
                  <div className="select label-wrapper label-wrapper--text-input">
                    <label htmlFor="country" title="Label">
                      Select Country
                    </label>
                    <div className="select__wrapper">
                      {isLoadingCountry ? (
                        <div className="loader-wrapper">
                          <span
                            className="loading loading--label-center"
                            aria-live="polite"
                          >
                            <span
                              className="loading__ball loading__ball--large loading__ball--emphasised"
                              aria-hidden="true"
                            ></span>
                            <span aria-hidden="true" className="loading__text">
                              Checking for your options
                            </span>
                            <span className="loading__sr-only-text">
                              Checking for your options
                            </span>
                          </span>
                        </div>
                      ) : null}
                      <div className="select__wrapper">
                        <select
                          value={selectedCountry}
                          onChange={handleCountryChange}
                          disabled={isLoadingCountry}
                        >
                          <option value="">Select a country</option>
                          {countryList.map((country, index) => (
                            <option key={index} value={country}>
                              {country}
                            </option>
                          ))}
                        </select>
                        <svg
                          focusable="false"
                          viewBox="0 0 24 24"
                          className="svg-icon select__chevron-down"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="m12.0003 15.5996-5.7857-5.785 1.414-1.4143 4.3717 4.3711 4.3717-4.3711 1.4141 1.4143-5.7858 5.785z"
                          ></path>
                        </svg>
                        <span className="select__border"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid-item">
                <div className="form-field">
                  <div className="select label-wrapper label-wrapper--text-input">
                    <label htmlFor="language" title="Label">
                      Select Language
                    </label>
                    <div className="select__wrapper">
                      <select
                        onChange={handleLanguageChange}
                        disabled={!selectedCountry}
                      >
                        <option value="">Select a language</option>
                        {languageList.map((language, index) => (
                          <option key={index} value={language}>
                            {language}
                          </option>
                        ))}
                      </select>
                      <svg
                        focusable="false"
                        viewBox="0 0 24 24"
                        className="svg-icon select__chevron-down"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="m12.0003 15.5996-5.7857-5.785 1.414-1.4143 4.3717 4.3711 4.3717-4.3711 1.4141 1.4143-5.7858 5.785z"
                        ></path>
                      </svg>
                      <span className="select__border"></span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Email Field */}
              <div className="grid-item">
                <div className="form-field">
                  <div className="input-field input-field--prefixed input-field--suffixed label-wrapper label-wrapper--text-input">
                    <label for="email" title="Label">
                      Enter Email
                    </label>
                    <div className="input-field__wrapper">
                      <input
                        type="text"
                        value={email1}
                        onChange={handleEmailChange}
                        onBlur={handleEmailChange}
                        disabled={!selectedCountry || !languageCode} // Disable email input field if either country or language code is not selected
                      />
                      <span className="input-field__prefix-label"></span>
                      <span className="input-field__suffix-label"></span>

                      <span className="input-field__border"></span>
                    </div>
                  </div>
                </div>
                <div className="form-field__content">
                  <span
                    id="helper-msg-id"
                    className="helper-text"
                    style={{ color: "rgb(204, 0, 8)" }}
                  >
                    {error && <p>{error}</p>}
                  </span>
                </div>
              </div>

              <div className="grid-item">
                <div className="search-verify-container">
                  <div className="searchbutton">
                    <Button
                      aria-disabled="false"
                      type="button"
                      className="btn btn--emphasised"
                      onClick={handleSearch}
                      disabled={isSearchButtonDisabled}
                    >
                      <span className="btn__inner">
                        <span className="btn__label">Search</span>{" "}
                      </span>{" "}
                    </Button>
                  </div>
                  {/* </div> */}

                  {verifyButtonVisible && (
                    <div className="verifybutton">
                      <Button
                        aria-disabled={true} // always disabled
                        disabled={true} // add this to ensure the button is disabled
                        // aria-disabled={!isMobileValid}---if need to enable this button uncomment it
                        type="button"
                        className="btn btn--emphasised openmodalverify"
                        // onClick={() => setShowVerifyOtpModal(true)}
                        onClick={handleVerifyButtonClick}
                      >
                        <span className="btn__inner">
                          <span className="btn__label">Verify</span>
                        </span>
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {isLoading && (
              <div>
                <span
                  className="loading loading--label-center"
                  aria-live="polite"
                >
                  <span
                    className="loading__ball loading__ball--large loading__ball--emphasised"
                    aria-hidden="true"
                  ></span>
                  <span aria-hidden="true" className="loading__text">
                    Checking for your options
                  </span>
                  <span className="loading__sr-only-text">
                    Checking for your options
                  </span>
                </span>
              </div>
            )}

            <Modal
              visible={modalOpen}
              escapable={false}
              handleCloseBtn={() => setModalOpen(false)}
            >
              <Prompt
                aria-labelledby={modalTitleId}
                titleId={modalTitleId}
                header={<ModalHeader ariaCloseTxt="Close prompt" />}
                footer={
                  <ModalFooter
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className="primary"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <div
                        className="passwordsentsuccessfullyok"
                        style={{ textAlign: "center", margin: "auto" }}
                      >
                        <Button
                          aria-disabled="false"
                          class="btn btn--emphasised"
                          type="primary"
                        >
                          <span class="btn__inner">
                            <span class="btn__label">OK</span>{" "}
                          </span>{" "}
                        </Button>
                      </div>
                    </div>
                  </ModalFooter>
                }
              >
                <div className="form-field">
                  <div className="form-field__content">
                    <span
                      id="helper-msg-id"
                      className="helper-text"
                      style={{ color: "rgb(17, 17, 17)" }}
                    >
                      <Text> {[error1]}</Text>
                    </span>
                  </div>
                </div>
              </Prompt>
            </Modal>

            {/* {isTableVisible &&( */}
            {data && (
              <>
                <div className="regform">
                  <Text tagName="h2" headingSize="m">
                    Customer record
                  </Text>
                </div>

                <div className="regform1">
                  <Text className="text text--heading-xl">
                    All customer information will be kept with discretion and
                    not be used for other purpose
                  </Text>
                </div>
                <div class="outputbox">
                  <div className="table table--inset">
                    <Table>
                      <thead>
                        <tr>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Country Code</th>
                          <th>Email ID</th>
                          {isSmsEnabled && <th>Mobile no</th>}
                          {isSmsEnabled && <th>Mobile no verified</th>}
                        </tr>
                      </thead>
                      <tbody class="">
                        <tr>
                          <td>{data.firstName}</td>
                          <td>{data.lastName}</td>
                          <td>{data.countryCode}</td>
                          <td>{data.emailId}</td>
                          {isSmsEnabled && <td>{data.mobileNo}</td>}
                          {isSmsEnabled && (
                            <td>{isMobileNumberVerified ? "Yes" : "No"}</td>
                          )}
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>

                {data && (
                  <div class="resetpasswordbtn">
                    <Button
                      class="btn btn--emphasised"
                      onClick={() => setModalOpen(true)}
                    >
                      Reset Password
                    </Button>
                  </div>
                )}

                <Modal
                  visible={modalOpen}
                  escapable={false}
                  handleCloseBtn={handleCloseBtn}
                >
                  <Prompt
                    aria-labelledby={modalTitleId}
                    titleId={modalTitleId}
                    header={<ModalHeader ariaCloseTxt="Close prompt" />}
                    footer={
                      <ModalFooter>
                        <div
                          className="primary"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            position: "relative",
                            width: "100%",
                          }}
                        >
                          <div style={{ marginRight: "8px", flex: "1" }}>
                            <button
                              type="button"
                              onClick={() => setModalOpen(false)}
                              style={{
                                width: "100%",
                                // borderRadius: "4px 0 0 4px",
                                borderRadius: "25px",
                                backgroundColor: "rgb(17, 17, 17)",
                                border: "1px solid #ddd",
                                padding: "14px 16px",
                                color: "#fff",
                                cursor: "pointer",
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                          <div style={{ marginLeft: "8px", flex: "1" }}>
                            <button
                              type="button"
                              onClick={handleOkClick}
                              disabled={
                                isSmsEnabled
                                  ? resetMethod.length === 0
                                  : !resetMethod.includes("email")
                              }
                              style={{
                                width: "100%",
                                // borderRadius: "0 4px 4px 0",
                                borderRadius: "25px",
                                backgroundColor: !isOkEnabled
                                  ? "#ddd"
                                  : "rgb(0, 88, 163)",
                                border: "none",
                                color: "#fff",
                                padding: "14px 16px",
                                cursor: !isOkEnabled
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              OK
                            </button>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "0",
                              bottom: "0",
                              left: "calc(50% - 1px)",
                              width: "1px",
                              backgroundColor: "#fff",
                              pointerEvents: "none",
                            }}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                      </ModalFooter>
                    }
                  >
                    <div className="form-field">
                      <fieldset className="checkbox-group" role="group">
                        <legend>Send new password to the customer</legend>
                        {isSmsEnabled ? (
                          <>
                            <span className="checkbox">
                              <input
                                type="checkbox"
                                id="email"
                                name="resetMethodEmail"
                                value="email"
                                checked={resetMethod.includes("email")}
                                onChange={() => {
                                  if (resetMethod.includes("email")) {
                                    // If email is already checked, uncheck email
                                    if (resetMethod.includes("sms")) {
                                      // If sms is also checked, only uncheck email
                                      setResetMethod("sms");
                                    } else {
                                      // If sms is not checked, only uncheck email
                                      setResetMethod("");
                                    }
                                  } else {
                                    // If email is not checked, check email
                                    if (resetMethod.includes("sms")) {
                                      // If sms is also checked, keep both checked
                                      setResetMethod("email,sms");
                                    } else {
                                      // If sms is not checked, only check email
                                      setResetMethod("email");
                                    }
                                  }
                                }}
                              />
                              <span className="checkbox__symbol"></span>
                              <span className="checkbox__label">
                                <label htmlFor="email">Email</label>
                              </span>
                            </span>
                            <span className="checkbox">
                              <input
                                type="checkbox"
                                id="sms"
                                name="resetMethodSms"
                                value="sms"
                                checked={resetMethod.includes("sms")}
                                disabled={isSmsEnabled && !data.mobileNo}
                                onChange={() => {
                                  if (resetMethod.includes("sms")) {
                                    // If sms is already checked, uncheck sms
                                    if (resetMethod.includes("email")) {
                                      // If email is also checked, only uncheck sms
                                      setResetMethod("email");
                                    } else {
                                      // If email is not checked, only uncheck sms
                                      setResetMethod("");
                                    }
                                  } else {
                                    // If sms is not checked, check sms
                                    if (resetMethod.includes("email")) {
                                      // If email is also checked, keep both checked
                                      setResetMethod("email,sms");
                                    } else {
                                      // If email is not checked, only check sms
                                      setResetMethod("sms");
                                    }
                                  }
                                }}
                              />
                              <span className="checkbox__symbol"></span>
                              <span className="checkbox__label">
                                <label htmlFor="sms">SMS</label>
                              </span>
                            </span>
                          </>
                        ) : (
                          <span className="radio">
                            <input
                              type="radio"
                              id="email"
                              name="resetMethod"
                              value="email"
                              onChange={() => setResetMethod("email")}
                              checked={resetMethod === "email"}
                            />
                            <span className="radio__symbol"></span>
                            <span className="radio__label">
                              <label htmlFor="email">Email</label>
                            </span>
                          </span>
                        )}
                      </fieldset>
                    </div>
                  </Prompt>
                </Modal>

                <Modal
                  visible={showPasswordSentModal}
                  escapable={false}
                  handleCloseBtn={() => setShowPasswordSentModal(false)}
                >
                  <Prompt
                    aria-labelledby={modalTitleId}
                    titleId={modalTitleId}
                    header={<ModalHeader ariaCloseTxt="Close prompt" />}
                    footer={
                      <ModalFooter
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <div
                          className="primary"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <div
                            className="passwordsentsuccessfullyok"
                            style={{ textAlign: "center", margin: "auto" }}
                          >
                            <Button
                              aria-disabled="false"
                              class="btn btn--emphasised"
                              type="primary"
                            >
                              <span class="btn__inner">
                                <span class="btn__label">OK</span>{" "}
                              </span>{" "}
                            </Button>
                          </div>
                        </div>
                      </ModalFooter>
                    }
                  >
                    <div class="form-field">
                      <div class="form-field__content">
                        <span
                          id="helper-msg-id"
                          class="helper-text"
                          style={{ color: "rgb(17, 17, 17)" }}
                        >
                          <Text tagName="h2" headingSize="m">
                            Password has been sent successfully.
                          </Text>
                        </span>
                      </div>
                    </div>
                  </Prompt>
                </Modal>
              </>
            )}
          </div>

          {/* Footer code */}
          <div className="footer">
            <div className="jumbobtn">
              <JumboButton
                variant="primary"
                className="jumbo-btn jumbo-btn--emphasised jumbo-btn--footer"
              >
                <span
                  className="policy-text"
                  onClick={() => setshowPolicyModal(true)}
                >
                  Policy
                </span>
                <span className="feedback-text">
                  Feedback&nbsp;&nbsp;
                  <span
                    className="feedback-text-desc"
                    style={{ fontSize: "80%" }}
                  >
                    We always welcome new ideas and feedback. Please share your
                    feedback to{" "}
                    <a href="mailto:dl.icaps.devops-team.gl@ingka.com">Email</a>
                  </span>
                </span>
              </JumboButton>
            </div>
          </div>

          <Modal
            visible={showPolicyModal}
            escapable={false}
            handleCloseBtn={() => setshowPolicyModal(false)}
          >
            <Prompt
              aria-labelledby={modalTitleId}
              titleId={modalTitleId}
              header={<ModalHeader ariaCloseTxt="Close prompt" />}
              footer={
                <ModalFooter
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div
                    className="primary"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className="passwordsentsuccessfullyok"
                      style={{ textAlign: "center", margin: "auto" }}
                    >
                      <Button
                        aria-disabled="false"
                        class="btn btn--emphasised"
                        type="primary"
                      >
                        <span class="btn__inner">
                          <span class="btn__label">OK</span>{" "}
                        </span>{" "}
                      </Button>
                    </div>
                  </div>
                </ModalFooter>
              }
            >
              <div className="form-field">
                <div className="form-field__content">
                  <span id="helper-msg-id" className="helper-text">
                    <p>
                      Hantera is developed by Non-Ingka Group and will require
                      your IKEA Email ID and Password to login into Hantera.
                      Co-Worker needs to authenticate using AD. For resetting
                      the customer's password Co-worker needs customer Email and
                      the country he belongs for fetching the data. Your short
                      id will be stored for audit log. Once you close the
                      browser, the content will be permanently deleted from your
                      web browser. If you wish to remove your access for
                      Hantera, please contact your responsible manager.
                    </p>
                  </span>
                </div>
              </div>
            </Prompt>
          </Modal>
        </>
      )}
    </>
  );
};
const ProfileContent = ({ countryCode }) => {
  const [graphData, setGraphData] = useState(null);
  useEffect(() => {
    const fetchGraphData = async () => {
      try {
        const response = await axios.get(
          `${API_HOST}/hantera/graph-data/${countryCode}`
        );
        setGraphData(response.data);
      } catch (error) {}
    };
    fetchGraphData();
  }, [countryCode]);
  return (
    <>
      <p>Country Code: {countryCode}</p>
    </>
  );
};
const MainContent = () => {
  const [selectedCountry, setSelectedCountry] = useState("");
  const [adminSA, setAdminSA] = useState(false); // Separate state for adminSA
  const [adminBH, setAdminBH] = useState(false); // Separate state for adminBH
  const [languageList, setLanguageList] = useState([]);
  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
  };
  return (
    <div className="App">
      <AuthenticatedTemplate>
        <CountryList
          onCountrySelect={handleCountrySelect}
          adminSA={adminSA}
          setAdminSA={setAdminSA}
          adminBH={adminBH}
          setAdminBH={setAdminBH}
        />
        {selectedCountry && <ProfileContent countryCode={selectedCountry} />}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div className="textlogincenter">
          <h5 className="card-title">
            Please click on LOGIN to reset password for customer
          </h5>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
};
export default function App() {
  return (
    <PageLayout>
      <MainContent />
    </PageLayout>
  );
}